import { QUERY_KEY, TOKEN_SCOPE } from '@kc-console/context';
import { getConsoleBaseUrl, STATUS_CODE } from '@kc-console/core';

import { getRequestUrlData } from '../../utils/getRequestUrlData';

import type { ServiceAppState } from '@kc-console/context';
import type { Guard } from '../../types';

/**
 * 접속하려는 URL의 query에 필요한 데이터만 정상적으로 붙어있는지 체크합니다.
 * @description
 * - 접근하려는 페이지의 serviceKeyword를 URL을 파싱하여 취득합니다.
 * - 접근하려는 페이지의 scope을 meta api로부터 질의하여 취득합니다.
 * - meta api로 질의하는 postUrlValidation은 리전과 무관합니다.
 * - project scope 이 아닌 경우에는 필요없는 정보를 제거하는 것 이외에 url query 에 domain_id 가 유효한지 검증하고 보정하는 로직을 추가 수행합니다.
 */
export const validateQueryGuard: Guard<ServiceAppState> = async ({ context, state }) => {
  const { scope, domainId } = state;
  const { urlObj } = getRequestUrlData(context);

  let isDisallowedQueryExist = false;

  if (scope === TOKEN_SCOPE.PROJECT) {
    if (urlObj.searchParams.has(QUERY_KEY.DOMAIN_ID)) {
      urlObj.searchParams.delete(QUERY_KEY.DOMAIN_ID);
      isDisallowedQueryExist = true;
    }
  } else {
    if (urlObj.searchParams.has(QUERY_KEY.PROJECT_ID)) {
      urlObj.searchParams.delete(QUERY_KEY.PROJECT_ID);
      isDisallowedQueryExist = true;
    }

    if (urlObj.searchParams.has(QUERY_KEY.DOMAIN_ID)) {
      const queryDomainId = urlObj.searchParams.get(QUERY_KEY.DOMAIN_ID);

      if (queryDomainId !== domainId) {
        urlObj.searchParams.set(QUERY_KEY.DOMAIN_ID, domainId);
        isDisallowedQueryExist = true;
      }
    }
  }

  if (isDisallowedQueryExist) {
    return {
      redirect: {
        destination: `${getConsoleBaseUrl(urlObj.origin)}${urlObj.pathname}${urlObj.search}`,
        permanent: false,
      },
    };
  }

  return { status: STATUS_CODE.OK };
};

validateQueryGuard.displayName = 'validateQueryGuard';
